import { isNull } from "@/utils/fangerUtils";

const allColumns = {
  /**共有 */
  name: {
    label: "名称",
    prop: "name",
    whereSql: "like",
    minWidth: 160,
  },
  outInWarehouseName: {
    label: "出入库单名称",
    prop: "name",
    whereSql: "like",
    minWidth: 160,
  },
  remarks: {
    label: "备注",
    prop: "remarks",
    minWidth: 160,
  },
  operateTime: {
    label: "操作时间",
    prop: "operateTime",
    type: "date",
    minWidth: 160,
  },
  operatorName: {
    label: "操作人",
    prop: "operatorName",
    search: false,
    minWidth: 120,
  },
  /**产品 */
  productName: {
    label: "产品名称",
    prop: "productName",
    whereSql: "like",
    showRedSearch: true,
    minWidth: 100,
  },
  productNameByProductId: {
    label: "产品名称",
    prop: "productId",
    type: "cache",
    cacheKey: "product",
    cacheCode: "productId",
    cacheValue: "productName",
    minWidth: 160,
  },
  classification: {
    label: "产品规格",
    prop: "classification",
    whereSql: "like",
    minWidth: 120,
  },
  eqptCode: {
    label: "设备号",
    prop: "eqptCode",
    whereSql: "like",
    minWidth: 120,
  },
  productType: {
    label: "产品类型",
    prop: "productType",
    type: "dict",
    dictKey: "productType",
    sort: true,
    minWidth: 120,
  },
  supplier: {
    label: "供应商",
    prop: "supplier",
    type: "dict",
    dictKey: "supplier",
    sort: true,
    minWidth: 120,
  },
  supplierModel: {
    label: "供应商型号",
    prop: "supplierModel",
    whereSql: "like",
    minWidth: 120,
  },
  internalModel: {
    label: "内部型号",
    prop: "internalModel",
    minWidth: 120,
  },
  usageType: {
    label: "使用类型",
    prop: "usageType",
    type: "dict",
    dictKey: "usageType",
    minWidth: 120,
  },
  inventoryOperationType: {
    label: "库存操作",
    prop: "inventoryOperationType",
    type: "dict",
    dictKey: "inventoryOperationType",
    minWidth: 120,
  },
  productUnit: {
    label: "产品单位",
    prop: "productUnit",
    search: false,
    minWidth: 120,
  },
  checkingOutInventoryTotal: {
    label: "盘点中出库总量",
    prop: "checkingOutInventoryTotal",
    search: false,
    minWidth: 120,
  },
  imageUrl: {
    label: "图片",
    prop: "imageUrl",
    search: false,
    type: "img",
    minWidth: 160,
  },

  /**字典 */
  libraryName: {
    label: "字典名称",
    prop: "libraryName",
    whereSql: "like",
    minWidth: 120,
  },
  libraryCode: {
    label: "字典编码",
    prop: "libraryCode",
    whereSql: "like",
    minWidth: 120,
  },
  libraryDesc: {
    label: "字典描述",
    prop: "libraryDesc",
    whereSql: "like",
    minWidth: 120,
  },
  libraryCreatetime: {
    label: "创建时间",
    prop: "libraryCreatetime",
    type: "date",
    minWidth: 160,
  },
  /**仓库 */
  warehouseNameByWarehouseId: {
    label: "仓库名称",
    prop: "warehouse",
    type: "cache",
    cacheKey: "warehouse",
    cacheCode: "warehouseId",
    cacheValue: "warehouseName",
    minWidth: 100,
  },
  warehouseName: {
    label: "仓库名称",
    prop: "warehouseName",
    whereSql: "like",
    minWidth: 120,
  },
  warehouseCode: {
    label: "仓库编码",
    prop: "warehouseCode",
    whereSql: "like",
    minWidth: 120,
  },
  warehouseAddress: {
    label: "仓库地址",
    prop: "warehouseAddress",
    whereSql: "like",
    minWidth: 120,
  },
  createTime: {
    label: "创建时间",
    prop: "createTime",
    type: "date",
    minWidth: 160,
  },
  // 出入库

  contractNo: {
    label: "合同编号",
    prop: "contractNo",
    minWidth: 120,
  },
  projectNo: {
    label: "项目编号",
    prop: "projectNo",
    minWidth: 120,
  },
  workContactNo: {
    label: "工作联系函编号",
    prop: "workContactNo",
    minWidth: 120,
  },
  batchNo: {
    label: "批次编号",
    prop: "batchNo",
    minWidth: 120,
  },
  inWarehouse: {
    label: "入库仓库",
    prop: "inWarehouse",
    type: "warehouse",
    minWidth: 120,
  },
  inWarehouseName: {
    label: "入库仓库",
    prop: "inWarehouse",
    type: "warehouse",
    minWidth: 120,
  },
  inWarehouseTime: {
    label: "入库时间",
    prop: "inWarehouseTime",
    type: "date",
    minWidth: 160,
  },
  outWarehouseTime: {
    label: "出库时间",
    prop: "outWarehouseTime",
    type: "date",
    minWidth: 160,
  },
  outWarehouse: {
    label: "出库仓库",
    prop: "outWarehouse",
    type: "warehouse",
    minWidth: 120,
  },
  outWarehouseName: {
    label: "出库仓库",
    prop: "outWarehouse",
    type: "warehouse",
    minWidth: 120,
  },
  outInWarehouseStatus: {
    // 出入库状态
    label: "状态",
    prop: "status",
    type: "dict",
    dictKey: "outInStatus",
    minWidth: 120,
  },
  outInType: {
    // 出入库类型
    label: "类型",
    prop: "type",
    type: "dict",
    dictKey: "outInType",
    minWidth: 120,
  },
  // 申请单
  applicant: {
    label: "申请人",
    prop: "applicant",
    minWidth: 120,
  },
  applicationTime: {
    label: "申请时间",
    prop: "applicationTime",
    type: "date",
    minWidth: 160,
  },
  outInStatus: {
    label: "出入库类型",
    prop: "outInStatus",
    type: "dict",
    dictKey: "outInStatus",
    minWidth: 120,
  },
  applicationFormStatus: {
    label: "申请单状态",
    prop: "status",
    type: "dict",
    dictKey: "applicationFormStatus",
    minWidth: 120,
  },
  applicationFormType: {
    label: "申请单类型",
    prop: "type",
    type: "dict",
    dictKey: "applicationType",
    minWidth: 120,
  },
  type: {
    label: "申请单类型",
    prop: "type",
    type: "dict",
    dictKey: "applicationType",
    minWidth: 120,
  },
  approvalStatus: {
    label: "审批状态",
    prop: "approvalStatus",
    type: "dict",
    dictKey: "approvalStatus",
    minWidth: 120,
  },
  rejectRemarks: {
    label: "驳回理由",
    prop: "rejectRemarks",
    minWidth: 120,
  },
  approver: {
    label: "审批人",
    prop: "approver",
    minWidth: 120,
  },
  approvalTime: {
    label: "审批时间",
    prop: "approvalTime",
    type: "date",
    minWidth: 160,
  },
  // 产品出入库记录
  productNum: {
    label: "产品数量",
    prop: "productNum",
    propType: "number",
    minWidth: 120,
  },
  // 已入数量//已出数量
  completeNum: {
    label: "已入数量",
    prop: "completeNum",
    propType: "number",
    minWidth: 120,
  },
  // 盘点备注
  checkInventoryDisposalMode: {
    label: "盘点备注",
    prop: "checkInventoryDisposalMode",
    minWidth: 120,
  },
  // 项目名称
  projectName: {
    label: "项目名称",
    prop: "projectName",
    minWidth: 120,
  },
  // 未入数量//未出数量
  incompleteNum: {
    label: "未入数量",
    prop: "incompleteNum",
    propType: "number",
    minWidth: 120,
  },
  // 显示数量
  showNum: {
    label: "数量",
    prop: "showNum",
    search: false,
    minWidth: 120,
  },
  // 盘库
  checkInventoryRecordName: {
    label: "名称",
    prop: "checkInventoryRecordName",
    minWidth: 120,
  },
  startTime: {
    label: "开始时间",
    prop: "startTime",
    minWidth: 160,
  },
  endTime: {
    label: "结束时间",
    prop: "endTime",
    minWidth: 160,
  },
  checkStartTime: {
    label: "清点开始时间",
    prop: "checkStartTime",
    minWidth: 160,
  },
  checkEndTime: {
    label: "清点结束时间",
    prop: "checkEndTime",
    minWidth: 160,
  },
  inventoryTotal: {
    label: "应在库",
    prop: "inventoryTotal",
    minWidth: 120,
  },
  realInventoryTotal: {
    label: "实时库存",
    prop: "realInventoryTotal",
    minWidth: 120,
  },
  approvalInventoryTotal: {
    label: "实际库存",
    prop: "approvalInventoryTotal",
    minWidth: 120,
  },
  recipient: {
    label: "领取人",
    prop: "recipient",
    minWidth: 120,
  },
  inInventoryTotal: {
    label: "入库总量",
    prop: "inInventoryTotal",
    type: "input",
    minWidth: 120,
  },
  actualTotal: {
    label: "实际在库",
    prop: "actualTotal",
    type: "input",
    propType: "number", //inputType
    compareProp: "inventoryTotal", //比较对象
    minWidth: 120,
  },
  disposalMode: {
    label: "处理方式",
    prop: "disposalMode",
    type: "select",
    dictKey: "disposalMode",
    minWidth: 120,
  },
  outInventoryTotal: {
    label: "出库总量",
    prop: "outInventoryTotal",
    minWidth: 120,
  },
  inventoryStatus: {
    // 库存状态
    label: "库存状态",
    prop: "inventoryStatus",
    type: "dict",
    dictKey: "inventoryStatus",
    minWidth: 120,
  },
  returnInWarehouse: {
    // 重新入库
    label: "重新入库",
    prop: "returnInWarehouse",
    type: "dict",
    dictKey: "returnInWarehouse",
    minWidth: 120,
  },
  // 库存
  checkStatus: {
    // 盘点状态
    label: "盘点状态",
    prop: "checkStatus",
    type: "dict",
    dictKey: "checkStatus",
    minWidth: 120,
  },
  firstInWarehouseTime: {
    // 首次入库时间
    label: "首次入库时间",
    prop: "firstInWarehouseTime",
    type: "date",
    sort: true,
    minWidth: 180,
  },
  // 库存报表
  openingInventory: {
    label: "期初库存",
    prop: "openingInventory",
    minWidth: 120,
  },
  endingInventory: {
    label: "期末库存",
    prop: "endingInventory",
    minWidth: 120,
  },
  inboundQuantity: {
    label: "入库量",
    prop: "inboundQuantity",
    minWidth: 120,
  },
  outboundQuantity: {
    label: "出库量",
    prop: "outboundQuantity",
    minWidth: 120,
  },
  realtimeInventory: {
    label: "实时库存",
    prop: "realtimeInventory",
    minWidth: 120,
  },
};

/**
 * 获取自定义表格列
 * @param {*} customColsList
 */
export const getCustomTableCols = (customColsList) => {
  const reTableCols = [];
  customColsList.forEach((element) => {
    switch (typeof element) {
      case "string":
        const col = allColumns[element];
        if (!isNull(col)) {
          reTableCols.push(col);
        }
        break;
      case "object":
        reTableCols.push(element);
        break;
    }
  });
  return reTableCols;
};

/**
 * 获取指定列
 * @param {*} key
 * @returns
 */
export const getTableColsByKey = (key) => {
  return allColumns[key];
};
